import duoLogo from '../../../images/duoLogo.png'
import awsLogo from '../../../images/awsLogo.png'
import s1Logo from '../../../images/s1Logo.png'
import ms365 from '../../../images/ms365.png'

export const IntegrationTypeAWS = 'aws/Initialize'
export const IntegrationTypeDuo = 'duo/poll'
export const IntegrationTypeO365 = 'o365/Initialize'
export const IntegrationTypeSentinelOne = 'sentinelone/poll'
export const IntegrationTypeMimecast = 'mimecast/poll'

export const INTEGRATION_STATUS = {
  'INIT': 'initializing',
  'OK': 'ok',
  'ERROR': 'error',
  'DELETED': 'deleted'
}

export const cloudModuleMetadata = [
  {
    title: 'Amazon Web Services',
    subtitle: 'Kinesis',
    image: awsLogo,
    imageHeight: 60,
    setupGuideLink: 'https://blumira.help/aws',
    description: '',
    integrationType: IntegrationTypeAWS
  },
  {
    title: 'Duo Security',
    subtitle: 'Authentication and endpoint',
    image: duoLogo,
    imageHeight: 70,
    setupGuideLink: 'https://blumira.help/duo',
    description: 'This cloud connector fetches events from the Duo Security Admin API. There are prerequisites that need to be completed in the Duo Admin Panel before continuing. Please open our setup guide in another browser window, then click Next below to get started.',
    integrationType: IntegrationTypeDuo
  },
  {
    title: 'Microsoft 365',
    subtitle: 'Security event logs and alerts',
    image: ms365,
    setupGuideLink: 'https://blumira.help/m365',
    description: 'This cloud connector ingests audit logs from Microsoft 365. There are prerequisites that need to be completed in the Microsoft Admin Center before continuing. Please open our setup guide in another browser window, then click Next below to get started.',
    integrationType: IntegrationTypeO365
  },
  {
    title: 'SentinelOne',
    subtitle: 'Alerts, Activities, and Threats',
    image: s1Logo,
    setupGuideLink: 'https://blumira.help/sentinelone',
    description: 'This cloud connector ingests Alerts and Activities logs from SentinelOne. There are prerequisites that need to be completed in SentinelOne before continuing. Please open our setup guide in another browser window, then click Next below to get started.',
    integrationType: IntegrationTypeSentinelOne
  },
  {
    title: 'Mimecast',
    subtitle: 'Audit, Release, Rejection, and SIEM',
    image: null, // handled with an svg
    setupGuideLink: 'https://blumira.help/mimecast',
    description: 'This cloud connector ingests audit, release, rejection, and SIEM logs from Mimecast. There are prerequisites that need to be completed in the Mimecasst Administration Console before continuing. Please open our setup guide in another browser window, then click Next below to get started.',
    integrationType: IntegrationTypeMimecast
  },
]

export const cloudModuleConfigFieldLabels = {
  [IntegrationTypeDuo]: {
    'secret': {
      "ikey": "Duo-provided Integration Key",
      "skey": "Duo-provided Secret Key",
      "api_hostname": "Duo-provided API Hostname",
    },
  },
  [IntegrationTypeO365]: {
    'secret': {
      "client_id": "Application (client) ID",
      "tenant_id": "Directory (tenant) ID",
      "client_secret": 'Client Secret "Value"',
    },
  },
  [IntegrationTypeAWS]: {
    'secret': {
      "aws_access_key": "Access Key ID",
      "aws_secret_access_key": "Secret Access Key",
      "aws_region": "AWS Region",
    },
    'configuration': {
      "stream_name": "Stream Name",
    },
  },
  [IntegrationTypeSentinelOne]: {
    'secret': {
      "management_url": "Management URL",
      "api_token": "API Token",
      "account_id": "Account ID",
      "site_id": "Site ID",
    },
  },
  [IntegrationTypeMimecast]: {
    'secret': {
      "app_id": "Application ID",
      "app_key": "Application Key",
      "access_key": "Access Key",
      "secret_key": "Secret Key",
      "management_url": "Global Base Root URL"
    }
  }
}
